import { OperationProcess } from './operation-process';
import { FilterableInterface } from './filterable.interface';

export class Print implements FilterableInterface {
  constructor(
    public hash: string,
    public reference: string,
    public material: string,
    public operationProcess: OperationProcess,
  ) { }

  get filterableData() {
    return `${ this.reference }`.toLowerCase();
  }

  get name() {
    return `${ this.reference }`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/print.ts